import { render, staticRenderFns } from "./DataMangeEdit.vue?vue&type=template&id=4cde402a&scoped=true"
import script from "./DataMangeEdit.vue?vue&type=script&lang=js"
export * from "./DataMangeEdit.vue?vue&type=script&lang=js"
import style0 from "./DataMangeEdit.vue?vue&type=style&index=0&id=4cde402a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cde402a",
  null
  
)

export default component.exports